import hyperdom from 'hyperdom'
import BasePaymentMethod from '../methods/basePaymentMethod.jsx'
import formatPrice from '../../../../packages/ui-helpers/formatPrice.js'
import formats from 'root-packages/dates/formats.js'
import formatDate from 'root-packages/dates/formatDate.js'

export default class Deposit extends BasePaymentMethod {
  constructor (payment, paymentMethods, depositProminenceEnabled) {
    super(payment)
    this.paymentMethods = paymentMethods
    this.depositProminenceEnabled = depositProminenceEnabled
    if (this.payment.booking.booking.paymentOptions.deposit) {
      this.payment.booking.booking.paymentOptions.deposit.tempDesiredPaymentAmount = this.payment.booking.booking.paymentOptions.deposit.amount
      this.payment.booking.booking.paymentOptions.deposit.desiredPaymentAmount = this.payment.booking.booking.paymentOptions.deposit.amount
    }
  }

  amount () {
    return this.payment.booking.booking.paymentOptions.deposit.desiredPaymentAmount
  }

  eligible () {
    return (!!this.payment.booking.booking.paymentOptions.deposit && this.paymentMethods.eligible.length)
  }

  changeDepositAmount () {
    this.payment.modals.show({
      classNames: 'payment-options__change_deposit_modal',
      render: () => this.renderUpdateDepositModal(),
    })
  }

  setDepositAmount () {
    if (this.depositAmountValid()) {
      this.payment.booking.booking.paymentOptions.deposit.desiredPaymentAmount = Number(this.payment.booking.booking.paymentOptions.deposit.tempDesiredPaymentAmount)
      this.payment.modals.close()
    }
  }

  depositAmountValid () {
    return (Number(this.payment.booking.booking.paymentOptions.deposit.tempDesiredPaymentAmount) >= this.payment.booking.booking.paymentOptions.deposit.amount &&
      Number(this.payment.booking.booking.paymentOptions.deposit.tempDesiredPaymentAmount) <= this.payment.booking.booking.totalAmount)
  }

  renderUpdateDepositModal () {
    return <div>
      <div className='modal__header'>
        <h3>Change deposit</h3>
        <i className='modal__exit' onclick={(ev) => {
          ev.preventDefault()
          this.payment.modals.close()
        }}></i>
      </div>
      <div className='modal__price'>
        <label for='depositAmount'>Amount</label>
        <span class='payment-options__deposit_input_price'>
          <i>{this.payment.departure.prices.currency}</i>
          <input class='o-form-item__txt-input update_deposit__amount'
            binding={[this.payment.booking.booking.paymentOptions.deposit, 'tempDesiredPaymentAmount']}
            id='depositAmount'/>
        </span>
      </div>
      {!this.depositAmountValid()
        ? <div class='clearfix'>
          <div class='o-form-item__warning no-arrow payment-options__change_deposit_modal_deposit_error'>
            Deposit payment amount must be between {formatPrice({
              currency: this.payment.departure.prices.currency,
              amount: this.payment.booking.booking.paymentOptions.deposit.amount,
            })} and {formatPrice({
              currency: this.payment.departure.prices.currency,
              amount: this.payment.booking.booking.totalAmount,
            })}
          </div>
        </div>
        : undefined}
      <div className='update_deposit__actions'>
        <a className=' btn-secondary update_deposit__actions_update' href='#' onclick={(ev) => {
          ev.preventDefault()
          this.setDepositAmount()
        }}>Update</a>
      </div>
    </div>
  }

  render () {
    const prices = this.payment.booking.booking.paymentOptions

    return <label data-test={'payment-type-deposit'} class={['o-choice-item payment-options__item payment-options__item__deposit',
      {'-selected': this.payment.paymentOption() === this},
      {'deposit-prominence': this.depositProminenceEnabled},
    ]}>
      <input type='radio' class='o-choice-item__radio' name='payment-type'
        binding={[this.payment.paymentOptions, 'selected']}
        value={this}/>
      <div className='o-choice-item__content payment-option__container'>
        <div>
          <div className='payment-option__title'>
            <div className='payment-option__title__header'>Pay only a deposit</div>
            {this.renderDepositSubTitle(prices)}
          </div>
        </div>
        <div>
          <div className='payment-option__price'>
            <div className='payment-option__price-val price-blue'>
              {formatPrice({
                currency: this.payment.departure.prices.currency,
                amount: this.payment.booking.booking.paymentOptions.deposit.desiredPaymentAmount,
              })}
            </div>
            <a className={['payment-option__price-change', {'-visible': this.payment.paymentOption() === this}]}
              onclick={() => this.changeDepositAmount()}>Change amount</a>
          </div>
        </div>
      </div>
      <div className={['payment-option__methods-container', {'show-expanded': this.payment.paymentOption() === this}]}>
        <div className='payment-options'>
          {
            this.payment.paymentOption() === this ? [
              this.paymentMethods.selected,
              this.paymentMethods.selected.renderTermsAndConditions(),
              this.paymentMethods.selected.renderPaymentSummary(),
            ] : undefined
          }
        </div>
      </div>
    </label>
  }

  renderDepositSubTitle (prices) {
    const epdDepositNoticeEnabled = this.payment.config.features.epdDepositNotice && this.payment.appliedEPDAmount()
    const remainingAmount = formatPrice({
      currency: this.payment.departure.prices.currency,
      amount: prices.full.amount - prices.deposit.tempDesiredPaymentAmount,
    })
    const dueDate = formatDate(prices.full.dueDate, formats.dayMonthYear)
    return <div class="payment-option__subtitle due-date">
      {`The remaining amount of ${remainingAmount} is due on ${dueDate}${epdDepositNoticeEnabled ? '*' : ''}`}
    </div>
  }

}